import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered"
  }, [_vm.orderOneClickAction.orderReference ? _c("h2", {
    staticClass: "order-reference"
  }, [_c("span", [_vm._v(" " + _vm._s(_vm.orderOneClickAction.type === _vm.orderOneClickActionTypes.CUSTOMER_APPROVE.id ? "Approving" : "Declining") + " ")]), _c("span", [_vm._v("#" + _vm._s(_vm.orderOneClickAction.orderReference))]), _c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("For " + _vm._s(_vm.orderOneClickAction.customerFullName))])]) : _vm._e(), _vm.loading.isLoading ? _c("div", {
    staticClass: "mt-4 loading-container"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  }), _vm._v(" " + _vm._s(_vm.loading.text) + " ")], 1) : _vm._e(), _vm.loading.isComplete ? _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? [_vm.orderOneClickAction.type === _vm.orderOneClickActionTypes.CUSTOMER_APPROVE.id ? _c("p", [_vm._v(" This order is now awaiting for administrator validation. Please verify payment terms approving the order from its detailled page. ")]) : _vm.orderOneClickAction.type === _vm.orderOneClickActionTypes.CANCEL.id ? _c("p", [_vm._v(" This order has been successfully cancelled. ")]) : _vm._e(), _vm.orderOneClickAction.type === _vm.orderOneClickActionTypes.CUSTOMER_APPROVE.id ? _c(VBtn, {
    staticClass: "dfwa-btn --small --with-dark-bg",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.goToOrderDetails();
      }
    }
  }, [_vm._v(" View order ")]) : _vm._e()] : [_vm.orderOneClickAction.type === _vm.orderOneClickActionTypes.CUSTOMER_APPROVE.id ? _c("p", [_vm._v(" You approved this order. You'll be notified by e-mail of any change. ")]) : _vm.orderOneClickAction.type === _vm.orderOneClickActionTypes.CANCEL.id ? _c("p", [_vm._v(" Your order has been successfully cancelled. ")]) : _vm._e(), _c("p", [_vm._v("You can now close this browser tab")])]], 2) : _vm._e(), _vm.isRequestFinishedWithError ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.errorMessage))]), _c("p", [_vm._v("Sorry for the inconvenience. You can now close this browser tab")])]) : _vm._e(), _vm.alreadyUsedLink ? _c("div", [_c("p", [_vm._v("This one-time link has already been used and is no longer valid.")])]) : _vm._e(), !_vm.loading.isComplete && !_vm.alreadyUsedLink && !_vm.errorMessage ? _c("div", {
    staticClass: "d-flex flex-column align-center gap-2 mt-10"
  }, [_c("div", {
    ref: "turnstile",
    staticClass: "cf-turnstile"
  }), _vm.turnstile.error ? _c("div", {
    staticClass: "turnstile-error mt-4"
  }, [_vm._v(_vm._s(_vm.turnstile.error))]) : _vm._e(), !_vm.turnstile.error || _vm.turnstile.failedToLoad ? _c(VBtn, {
    staticClass: "dfwa-btn --small highlight",
    attrs: {
      disabled: _vm.turnstile.isLoading,
      loading: _vm.loading.isLoading || _vm.turnstile.isLoading,
      rounded: ""
    },
    on: {
      click: _vm.verifyCaptchaAndFetchOrder
    }
  }, [_vm._v(" " + _vm._s(_vm.orderOneClickAction.type === _vm.orderOneClickActionTypes.CUSTOMER_APPROVE.id ? "approve" : "decline") + " order ")]) : _vm._e(), _vm.turnstile.error && !_vm.turnstile.failedToLoad ? _c(VBtn, {
    staticClass: "dfwa-btn --small highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.refreshPage();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-redo mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Try Again ")], 1) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };